<div #printable class="printWrapper" *ngIf="brand && details">
  <div class="printContent">
    <div class="header">
      <div>
        <img [src]="brand.partner_image_url" alt="Logo" style="height: 52px" />
        <img [src]="brand.by_approbe" alt="Logo" style="height: 24px" />
        <p style="font-family: Verdana; color: #818181; font-size: 12px">
          "La puerta al mundo financiero"
        </p>
      </div>
      <div>
        <p style="color: #808080; text-align: end; font-family: Verdana">
          {{ brand.partner_name }}
        </p>
        <p style="color: #808080; text-align: end; font-family: Verdana">
          Nit: {{ brand.partner_nit }}
        </p>
        <p style="color: #808080; text-align: end; font-family: Verdana">
          Tel: {{ brand.partner_phone }}
        </p>
      </div>
    </div>

    <div class="welcome">
      <div class="welcomeText">
        <h1>Estimado, NombreDeudor:</h1>
        <p style="font-family: Verdana">
          No. Documento: {{ clientInfo.numeroDocumento }}
        </p>
      </div>
    </div>

    <div>
      <p
        style="
          color: #1d1d1b;
          line-height: 28px;
          margin-top: 0;
          font-size: 18px;
        "
      >
        Gracias por confiar en partner_name para ayudarte a cumplir tus metas.
      </p>
      <h1
        style="font-size: 26px; color: #222; font-size: 26px; margin-bottom: 0"
      >
        Conoce los detalles de tu crédito
      </h1>
    </div>

    <table
      style="
        width: 90% !important;
        margin: 0 auto;
        border-radius: 10px;
        border: 1px solid #191f38;
      "
    >
      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Fecha de uso del crédito
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            date
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Id del crédito
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.numCredit }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Numero de cuotas
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.fees }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Tasa E.A.
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.rateApprobeAnnual }} %
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Cuota de manejo
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.handlingFee }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Tarifa de firma digital
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.signature }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Seguro de vida deudor
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.insurance }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">FGA</p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ details.fGA }}
          </p>
        </td>
      </tr>

      <tr>
        <td>
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            Nombre del establecimiento
          </p>
        </td>
        <td>
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            {{ brand.partnerName }}
          </p>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <hr
            style="
              width: 100%;
              margin: 0;
              background-color: #191f38;
              height: 1px;
            "
          />
        </td>
      </tr>

      <tr>
        <td style="background-color: #f9f9f9">
          <p style="color: #191f38; padding-left: 20px; font-size: 18px">
            <b>Monto aprobado:</b>
          </p>
        </td>
        <td style="background-color: #f9f9f9">
          <p
            style="
              color: #191f38;
              text-align: end;
              padding-right: 20px;
              font-size: 18px;
            "
          >
            <b>{{ details.paid }}</b>
          </p>
        </td>
      </tr>
    </table>

    <div style="width: 90%; margin: 0 auto">
      <h1 style="margin-bottom: 0">Plan de pagos</h1>
    </div>

    <table
      style="
        width: 90%;
        margin: 0 auto;
        border-radius: 10px;
        border: 1px solid #191f38;
        background-color: #f9f9f9;
      "
    >
      paymentsPlan
    </table>

    <p
      style="
        width: 90%;
        margin: 20px auto;
        font-size: 16px;
        color: #191f38;
        line-height: 23px;
      "
    >
      “En caso de presentarse alguna mora en los pagos, iniciaremos el proceso
      de cobranza tal como está publicado en nuestra plataforma. Esto puede
      implicar cargos adicionales por comisiones de gestión. Además, al aceptar
      este plan, autorizas el uso de tus datos según nuestra Política de
      Privacidad, y nos reservamos el derecho de reportar la situación a las
      centrales de riesgo si fuera necesario. Al seguir adelante, reconoces y
      aceptas los valores, fechas de pago y condiciones acordados. Si tienes
      alguna consulta, ¡estamos aquí para ayudarte!."
    </p>

    <p style="width: 90%; margin: 25px auto; font-size: 20px; color: #191f38">
      Gracias por elegir {{ brand.partner_name }}
    </p>

    <div class="qrContainer">
      <img
        src="https://image-bnpl.s3.amazonaws.com/payments-qr.png"
        alt="QR Payments"
      />

      <div class="qrTextContainer">
        <p
          style="
            font-size: 27px;
            font-style: normal;
            font-weight: 700;
            line-height: 34px;
            color: #000;
          "
        >
          Escanea o usa el enlace para pagar tus cuotas
        </p>
        <a
          href="https://payments.approbe.co/"
          style="
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: 34px; /* 141.667% */
            text-decoration-line: underline;
            color: #3886ff;
          "
          >https://payments.approbe.co/</a
        >
      </div>
    </div>

    <table
      style="
        width: 90%;
        margin: 0 auto;
        border-radius: 18px;
        background-color: #00fcb9;
        padding: 20px;
      "
    >
      <tr>
        <td>
          <p style="font-size: 27px; color: #000; font-weight: 700">
            ¿Necesitas ayuda?
          </p>
        </td>

        <td>
          <p style="text-align: end; font-size: 16px; color: #191f38">
            info@approbe.co
          </p>

          <a
            href="https://api.whatsapp.com/send/?phone=17327987210&text=%C2%A1Hola+Eli%21&type=phone_number&app_absent=0"
            style="
              text-align: end;
              font-size: 16px;
              color: #191f38;
              margin-left: 165px;
            "
          >
            <img
              src="https://image-bnpl.s3.amazonaws.com/whatsapp-black.jpg"
              alt="Whatsapp"
            />
            Agente Eli
          </a>
        </td>
      </tr>
    </table>

    <div
      style="
        margin-top: 5%;
        width: 100%;
        background-color: #000000;
        padding: 20px;
      "
    >
      <div style="width: 100%; text-align: center">
        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://www.instagram.com/approbe_/?hl=es"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/socialRed/instagram.png"
            alt="Instagram"
          />
        </a>

        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://www.facebook.com/people/Approbe/100075656306227/"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/socialRed/facebook.png"
            alt="Facebook"
          />
        </a>

        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://www.linkedin.com/company/approbe-corp/mycompany/?viewAsMember=true"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/socialRed/linkedin.png"
            alt="Linkedin"
          />
        </a>

        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://x.com/ApproBE_?mx=2"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/socialRed/x.png"
            alt="X"
          />
        </a>

        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://www.youtube.com/channel/UCaM5KgsFXKs5SyNc7hhT7lw"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/socialRed/youtube.png"
            alt="Youtube"
          />
        </a>

        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://www.tiktok.com/@approbe"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/socialRed/tiktok.png"
            alt="Tik Tok"
          />
        </a>

        <a
          style="text-decoration: none; margin-right: 3%"
          href="https://api.whatsapp.com/send/?phone=17327987210&text=%C2%A1Hola+Eli%21&type=phone_number&app_absent=0"
        >
          <img
            src="https://image-bnpl.s3.amazonaws.com/whatsapp.png"
            alt="Whatsapp"
          />
        </a>
      </div>

      <div style="width: 100%">
        <img
          [src]="brand.partner_image_url"
          alt="Logo"
          style="height: 128px; padding: 20px 0 0 0; margin: 0 auto"
        />
      </div>
      <p
        style="
          font-size: 16px;
          font-weight: 400;
          line-height: 28px;
          color: #fff;
          text-align: center;
        "
      >
        "Esta es un mensaje automatizado, por favor no responda a este correo."
      </p>
    </div>
  </div>
</div>
